/* size-chart.js — accessible open/close for the PDP "Find Your Fit" modal.
   No dependencies. Supports multiple products on a page (each modal has its own id). */
(function () {
  'use strict';
  var lastFocused = null;

  function getFocusable(el) {
    return el.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, summary, [tabindex]:not([tabindex="-1"])');
  }
  function trapFocus(e, modal) {
    var f = getFocusable(modal);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openModal(modal) {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = getFocusable(modal); if (f.length) f[0].focus();
    modal._onKeydown = function (e) {
      if (e.key === 'Escape') closeModal(modal);
      else if (e.key === 'Tab') trapFocus(e, modal);
    };
    document.addEventListener('keydown', modal._onKeydown);
  }
  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (modal._onKeydown) { document.removeEventListener('keydown', modal._onKeydown); modal._onKeydown = null; }
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-size-chart-open]');
    if (opener) { e.preventDefault(); openModal(document.getElementById(opener.getAttribute('data-size-chart-open'))); return; }
    var closer = e.target.closest('[data-size-chart-close]');
    if (closer) { e.preventDefault(); closeModal(closer.closest('.size-chart-modal')); }
  });
})();
